import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_lista_compras, customAuth} from '@/FirebaseConfig'
import {secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        lista_de_compras_existencias:[],
        dialog: false,
        record_por_usuario:[],
        record_por_estado:[],
      },
      actions: {
        obtener_por_estado:({state})=>{
          state.record_por_estado = []
          coleccion_lista_compras.where('estado_de_proceso', '==', 'esperando')
          .onSnapshot(data=>{
            const registro = []
            data.docs.map( item => {
              registro.push({...item.data(), id_requerimiento: item.id, creado_el:  secondsToFullTimestamp(item.data().creado_el)})
            } )
            state.record_por_estado = registro
          } )
        },
        obtener_por_usuario: ({state})=>{
          if(!customAuth.currentUser) return 
          coleccion_lista_compras.where('estado_de_proceso', '==', 'esperando')
          .where('creado_por', '==',  customAuth.currentUser.displayName)
          .onSnapshot(data=>{
            const registro = []
            data.docs.map( item => {
              registro.push({...item.data(), id_requerimiento: item.id, creado_el:  secondsToFullTimestamp(item.data().creado_el)})
            } )
            state.record_por_usuario = registro
          } )
        },
        add:context=>{
          context.state.lista_de_compras_existencias.map(item=>{
            coleccion_lista_compras.add({...item,  creado_el: new Date, creado_por: customAuth.currentUser.displayName,estado_de_proceso:'esperando'})
          })
          context.commit('Helpers/launchSnackbar', 'Se ha registrado correctamente', { root: true })
          context.state.dialog = false
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.lista_de_compras_existencias=[]
          context.state.lista_de_compras_cotizaciones=[]
        },
        clean:(context, id_requerimiento)=> coleccion_lista_compras.doc(id_requerimiento).update({estado_de_proceso:'procesado'})
        ,
      },
     
  }
  